export default {"src":"/login-app/[GIT_HASH]/_next/static/media/automation_condition.ec691c80.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};